import RpIcon from "@/components/RpIcon";
import { toListItemDateString } from "@/utils/dateUtils";
import { getIconByBizType, getResourceByMcc, getResourceByMccName } from "@/utils/utils";
import {Box, Stack, styled, Typography} from "@mui/material";
import { useTranslation } from "react-i18next";
import { AssetTransItemType } from "./AssetsTransDetail.tsx";
import classes from './index.module.less';
import {TRANS_TYPE} from "@/constant/Constant.ts";

const StyledAvatarWrapper = styled('div')(({theme}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 32,
  height: 32,
  borderRadius: '50%',
  backgroundColor: theme.palette.background.card,
  'img': {
    maxWidth: '100%',
    maxHeight: '100%',
  }
}));

export default function AssetsTransItem({record}: { record: AssetTransItemType }) {
  const {t} = useTranslation("translation");

  // const {renderAssetLogStatus} = useRenders();

  const _isCardTrans = () => {
    return !!record.cardId;
  }

  const _transTile = () => {
    if (!record) return null;
    if (_isCardTrans()) {
      return (
        <Stack direction="row" alignItems={'center'} gap={'10px'}>
          {_renderIcon(true)}
          <Box>
            <p className={'text-primary'}>
              {record.merchantName ?? record.businessTypeDisplayName}
            </p>
            <p className={'tiny'}>
              {`\u2022\u2022\u2022\u2022 ${record.cardLast4}`} {toListItemDateString(record.createTime)}
            </p>
          </Box>
        </Stack>
      )
    } else {
      return <Stack direction="row" alignItems={'center'} gap={'10px'}>
          {_renderIcon(false)}
        <Box>
          <p className={'text-primary'}>{record.businessTypeDisplayName}</p>
          <p className={'tiny'}>{record.businessModuleDisplayName ?? ''}
            {(record.businessType == TRANS_TYPE.CARD_CONSUMPTION && !record.cardId) && <span>
                &nbsp;({t('card_is_deleted')})
              </span>}
          </p>
        </Box>
      </Stack>
    }
  }

  const _renderIcon = (isCardTrans: boolean) => {
    if (isCardTrans) {
      let icon = getResourceByMccName(record.merchantName);
      const merchantIcon = icon != null;
      if (!icon) icon = getResourceByMcc(record.mcc);
      let iconEl;
      if (icon) {
        iconEl = <img src={icon} style={{ filter: !merchantIcon ? 'grayscale(100%)' : 'none'}} />
      } else {
        iconEl = <RpIcon icon={"card"} size={18}/>
      }

      return merchantIcon ?
        <StyledAvatarWrapper>
          {iconEl}
        </StyledAvatarWrapper> :
        <StyledAvatarWrapper>
          {iconEl}
        </StyledAvatarWrapper>;
    } else {
      const icon = getIconByBizType(record.businessType);
      return <StyledAvatarWrapper>
        <RpIcon icon={icon ?? 'card'} size={18}/>
      </StyledAvatarWrapper>
    }
  }

  const getRightContent = () => {
    return (
      <Stack direction="column" className={'text-right'}>
        <Typography>
          <Typography className="text-primary" style={{ paddingInlineEnd: '4px' }}>{record.amount} &nbsp;{record.varietyCode?.toUpperCase()}</Typography>
          {/*<span className={'span'}>{record.varietyCode?.toUpperCase()}</span>*/}
        </Typography>
        {/* <p>
          <span className={'tiny'}>{renderAssetLogStatus(record)}</span>
          {_getCardTrans()}
        </p> */}
      </Stack>
    )
  }

  if (!record) return null;

  return <Box className={classes['flow-container']}>
    <Stack sx={{
      cursor:"pointer"
    }} direction="row" justifyContent={'space-between'} alignItems={'center'} className={classes['flow-container-list']}>
      <Box>
        {_transTile()}
      </Box>
      <Box>
        {getRightContent()}
      </Box>
    </Stack>
  </Box>;
}